<div class="h-100 overflow-auto crm-scroll">
  <div class="d-flex flex-row align-items-center justify-content-between px-4 py-3 bg-white position-sticky top-0 z-5">
    <h4 class="m-0 text-crm">
      {{
        !group_id
          ? ('create_new_role' | translate)
          : ('update_your_role' | translate) + (group?.name ? ' ' + group.name : '')
      }}
    </h4>
    @if (baseService.isMobile) {
      <app-button (onChangeClick)="onCloseSidebar()" [btnType]="'icon'" matTooltip="{{ 'close' | translate }}">
        <app-icon>close</app-icon>
      </app-button>
    }
  </div>

  <mat-divider class="my-2"></mat-divider>

  @if (isLoader) {
    <div class="loader w-100 d-flex justify-content-center">
      <mat-spinner style="width: 50px; height: 50px"></mat-spinner>
    </div>
  }

  @if (groupForm && !isLoader) {
    <div>
      <div class="d-flex flex-column gap-3 px-4 py-2" [formGroup]="groupForm">
        <div>
          <app-text-field
            label="{{ 'name_role' | translate }}"
            [formControl]="groupForm.controls.name"
            placeholder="{{ 'enter_the_name_of_the' | translate }}"
            [error]="groupForm.controls.name.touched && groupForm.controls.name.invalid"
            (focusout)="groupForm.controls.name.markAsTouched()"
          ></app-text-field>
          @if (groupForm.controls.name.touched && groupForm.controls.name.invalid) {
            <mat-hint class="text-danger"> {{ 'field_cannot_be_empty' | translate }}. </mat-hint>
          }
        </div>
        @if (isLoaderPermissions) {
          <div class="loader w-100 d-flex justify-content-center">
            <mat-spinner style="width: 50px; height: 50px"></mat-spinner>
          </div>
        }
        @if (!isLoaderPermissions && permissions.length) {
          <div>
            <h4>{{ 'rights_for_roles' | translate }}:</h4>
            @if (permissions.length > 1) {
              <div class="perm py-2" [ngStyle]="{ 'grid-template-columns': baseService.isMobile ? '1fr' : '1fr 1fr' }">
                <label class="perm__label"> {{ 'rights_for_all' | translate }}:</label>
                <mat-radio-group
                  [ngClass]="{ 'justify-content-end': !baseService.isMobile }"
                  class="perm__radio__btns"
                  (change)="onSelectRadioAll($event)"
                >
                  <mat-radio-button
                    [checked]="permissions.length && permissions.length === groupPermissions.length"
                    [value]="1"
                  >
                    {{ 'allowed' | translate }}
                  </mat-radio-button>
                  <mat-radio-button [checked]="!groupPermissions.length" [value]="0">
                    {{ 'denied' | translate }}
                  </mat-radio-button>
                </mat-radio-group>
              </div>
            }
            <p class="text-secondary">
              ({{ 'you_can_choose_from_several_options' | translate }})<br />
              <span class="text-dark">{{ 'the_user_is_entitled_to' | translate }}:</span>
            </p>
            <div class="group">
              @for (group of groupedPermissions; track group) {
                <mat-card>
                  <mat-card-header>
                    <mat-card-title>{{ 'permissions_types.' + group.type.toLowerCase() | translate }}: </mat-card-title>
                  </mat-card-header>
                  <mat-card-content>
                    <div class="group-permissions items-start">
                      @for (permission of group.permissions; track permission) {
                        <div class="perm py-2" [ngStyle]="{ 'grid-template-columns': '1fr' }">
                          <div
                            [class.w-max]="PERMISSIONS_KEYS.ACCESS_CHANNELS === permission.key"
                            [class.max-w-full]="PERMISSIONS_KEYS.ACCESS_CHANNELS === permission.key"
                          >
                            <div class="flex items-center gap-2">
                              <app-chip
                                (onChangeSelect)="onSelectRadio($event, permission)"
                                [isSelected]="groupPermissions.includes(permission.id)"
                                [name]="PERMISSIONS[permission.key] || permission.name"
                                [type]="CHIP_TYPES.SELECTABLE"
                              ></app-chip>
                            </div>
                          </div>
                        </div>
                      }
                    </div>
                  </mat-card-content>
                </mat-card>
              }
            </div>
          </div>
        }
      </div>
      <div class="bg-white d-flex position-sticky bottom-0 gap-2 p-4">
        <app-button class="mt-2" (onChangeClick)="onCloseSidebar()">{{ 'cancel' | translate }}</app-button>
        @if (group_id) {
          <app-button
            [customClass]="isHasChange ? 'bg-success' : ''"
            class="mt-2"
            (onChangeClick)="onUpdateGroup()"
            [disabled]="!isHasChange"
            >{{ 'save' | translate }}
          </app-button>
        }
        <div class="flex-fill"></div>
        @if (!group_id) {
          <app-button class="mt-2" (onChangeClick)="onCreateGroup()" [disabled]="isLoaderPermissions"
            >{{ 'save' | translate }}
          </app-button>
        }
        @if (group_id) {
          <app-button class="mt-2" [customClass]="'bg-danger'" (onChangeClick)="onDeleteGroup()">
            <app-icon class="text-white">delete</app-icon>
          </app-button>
        }
      </div>
    </div>
  }
</div>
